<template>
  <a-row :gutter="25">
    <a-col :xxl="12" :md="12" :sm="12" :xs="12">
      <sdCards headless>
        <EChartCard>
          <div class="card-chunk">
            <CardBarChart2>
              <sdHeading as="h1">{{ test }}</sdHeading>
              <span>{{$t('pages.home.gross-profit')}}</span>
              <p>
                <span class="growth-upward"> <sdFeatherIcons type="arrow-up" /> 25% </span>
                <span>Since last week</span>
              </p>
            </CardBarChart2>
          </div>
          <div class="card-chunk">
            <Chart
              class="growth"
              :height="180"
              :style="{
                marginBottom: '-5',
              }"
              :labels="['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul']"
              :datasets="[
                {
                  data: [20, 60, 50, 45, 50, 60, 70],
                  backgroundColor: '#EFEFFE',
                  hoverBackgroundColor: '#5F63F2',
                  label: 'Orders',
                  barPercentage: 1,
                },
              ]"
              :options="chartOptions"
            />
          </div>
        </EChartCard>
      </sdCards>
    </a-col>
    <a-col :xxl="12" :md="12" :sm="12" :xs="12">
      <sdCards headless>
        <EChartCard>
          <div class="card-chunk">
            <CardBarChart2>
              <sdHeading as="h1">28,94₺</sdHeading>
              <span>{{$t('pages.home.revenue')}}</span>
              <p>
                <span class="growth-downward"> <sdFeatherIcons type="arrow-down" /> 25% </span>
                <span>Since last week</span>
              </p>
            </CardBarChart2>
          </div>
          <div class="card-chunk">
            <Chart
              class="downward"
              :height="180"
              :style="{
                marginBottom: '-5',
              }"
              :labels="['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul']"
              :datasets="[
                {
                  data: [20, 60, 50, 45, 50, 60, 70],
                  backgroundColor: '#FFF0F6',
                  hoverBackgroundColor: '#FF69A5',
                  label: 'Revenue',
                  barPercentage: 1,
                },
              ]"
              :options="chartOptions"
            />
          </div>
        </EChartCard>
      </sdCards>
    </a-col>
  </a-row>
</template>
<script>
import { CardBarChart2, EChartCard } from '../style';
import Chart from '../../../components/utilities/chartjs';
import { Main } from '../../styled';

export default {
  name: 'Emmorce',
  components: {
    Main,
    CardBarChart2,
    EChartCard,
    Chart,
  },
  data() {
    return {
      test: '155',
      chartOptions: {
        legend: {
          display: false,
          labels: {
            display: false,
          },
        },
        scales: {
          yAxes: [
            {
              stacked: true,
              gridLines: {
                display: false,
              },
              ticks: {
                display: false,
              },
            },
          ],
          xAxes: [
            {
              stacked: true,
              gridLines: {
                display: false,
              },
              ticks: {
                display: false,
              },
            },
          ],
        },
      },
    };
  },
};
</script>
